export default {
  title: '重新设置密码',
  username: '请输入用户名',
  mobile: '请输入手机号',
  code: '请输入手机验证码',
  password: '请设置新密码',
  confirm: '请确认新密码',
  form: '设置新密码',
  js: {
    error: '失败',
    success: '成功',
    sendAgain: '重新发送',
    send: '发送验证码'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/password.js